import { useTranslation } from 'react-i18next';

import { Button } from '@/components/common/Button';
import { qcpRestFailureOf } from '@/lib/qcp/rest';

/**
 * Il fallimento di una lettura di QChinesePoker dal BFF (T1b). Due sole frasi, perche' il BFF non fa arrivare altro: «non disponibile»
 * (424 `E_QLASH_CAPABILITY_DISABLED`, riprovare non serve) o `fallback` (ogni altro esito) con «Riprova». Mai il testo del server.
 */
export function QcpRestNotice({ error, fallback, onRetry }: { error: unknown; fallback: string; onRetry: () => void }) {
  const { t } = useTranslation('chinesepoker');
  const nonDisponibile = qcpRestFailureOf(error) === 'non-disponibile';
  return (
    <div className="flex flex-col items-center gap-3 rounded-xl bg-bg-secondary p-4 text-center">
      <p className="text-sm text-danger">{nonDisponibile ? t('rest.unavailable') : fallback}</p>
      {!nonDisponibile && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          {t('rest.retry')}
        </Button>
      )}
    </div>
  );
}
